import { CHANGE_SERVICE_FAVORITE_STATUS } from '../constants';
import { inFavoriteSelector } from '../favorite/selectors';
import { deleteFromFavorite, addToFavorite } from '../../resources/index';
import { changeServiceFavoriteStatusSuccess } from '../favorite/actions';

const changeServiceFavoriteStatusMiddleware = ({
  dispatch,
  getState
}) => next => action => {
  const { type } = action;

  if (type !== CHANGE_SERVICE_FAVORITE_STATUS) {
    return next(action);
  }

  const state = getState();
  const inFavorite = inFavoriteSelector(state);

  if (inFavorite) {
    deleteFromFavorite().then(response => {
      if (response.code === 'SUCCESS' || response.code === 'OK') {
        dispatch(changeServiceFavoriteStatusSuccess(false));
      }
    });
  } else {
    addToFavorite().then(response => {
      if (response.code === 'SUCCESS' || response.code === 'OK') {
        dispatch(changeServiceFavoriteStatusSuccess(true));
      }
    });
  }

  return next(action);
};

export default changeServiceFavoriteStatusMiddleware;
